(() => {
  const canonicalOptions = form => Array.from(form.querySelectorAll('input[type="hidden"][data-sort-order][name^="properties["]'));
  const baseName = name => name.replace(/\s+\(\+\s*[^)]+\)(?=\]$)/, '');
  const cleanProperties = (form, properties) => {
    if (!form.querySelector('[data-kubson-prices]') || !properties) return properties;
    for (const input of canonicalOptions(form)) {
      const key = input.name.slice(11, -1);
      const base = baseName(input.name).slice(11, -1);
      if (key !== base && Object.prototype.hasOwnProperty.call(properties, key)) delete properties[base];
      if (Object.prototype.hasOwnProperty.call(properties, key)) properties[key] = input.value;
    }
    return properties;
  };
  window.KubsonProductPrices = { cleanProperties };
  const initialize = root => {
    root.querySelectorAll('[data-kubson-prices]').forEach(panel => {
      if (panel.dataset.initialized) return;
      const form = panel.closest('form');
      if (!form) return;
      panel.dataset.initialized = 'true';
      const variants = JSON.parse(panel.dataset.variants);
      const format = new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', { style: 'currency', currency: panel.dataset.currency });
      let charge = 0;
      let selectedVariant = null;
      const render = () => {
        const id = form.querySelector('[name="id"]')?.value;
        const variant = selectedVariant || variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        panel.querySelector('[data-options-price]').textContent = format.format(charge / 100);
        const compare = panel.querySelector('[data-config-compare]');
        const savings = Math.max(0, (variant.compare_at_price || 0) - variant.price);
        compare.hidden = !savings;
        compare.textContent = savings ? format.format((variant.compare_at_price + charge) / 100) : '';
        const savingsNote = panel.querySelector('[data-config-savings]');
        if (savingsNote) {
          savingsNote.hidden = !savings;
          if (savings) savingsNote.textContent = panel.dataset.savings.replace('__AMOUNT__', format.format(savings / 100));
        }
      };
      // Price context only. The pixel waits for Shopify's successful add event.
      form.addEventListener('submit', () => {
        try {
          const variant = variants.find(item => String(item.id) === String(form.querySelector('[name="id"]')?.value));
          const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
          if (!variant || !Number.isSafeInteger(quantity) || quantity < 1 ||
              !Number.isSafeInteger(variant.price) || !Number.isSafeInteger(charge) || charge < 0) return;
          window.Shopify?.analytics?.publish?.('kubson:configuration_add_context', {
            version: 1, variantId: String(variant.id), quantity,
            baseUnitCents: variant.price, optionUnitCents: charge,
            currency: panel.dataset.currency, pathname: window.location.pathname
          });
        } catch (_) { /* Analytics must never prevent a cart submission. */ }
      }, true);
      form.addEventListener('formdata', event => {
        for (const input of canonicalOptions(form)) {
          const base = baseName(input.name);
          if (base !== input.name && event.formData.has(input.name)) event.formData.delete(base);
          if (event.formData.has(input.name)) event.formData.set(input.name, input.value);
        }
      });
      window.addEventListener('zapiet:charge:changed', event => {
        if (!form.querySelector('.options-container')) return;
        const value = Number(event.detail?.charge);
        if (Number.isFinite(value)) charge = Math.round(value * 100);
        render();
      });
      document.addEventListener('variant:changed', event => {
        if (!form.contains(event.target) && !event.target.contains?.(form)) return;
        selectedVariant = event.detail?.variant || null;
        charge = 0;
        render();
      });
      window.addEventListener('zapiet:options:ready', render);
      render();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.body) {
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-kubson-prices]') || node.querySelector('[data-kubson-prices]')) initialize(node.parentElement || node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
